module.exports = __webpack_public_path__ + "img/edit.a46f9813.svg";